import { useEffect } from "react";

const loadedFonts = new Set();

/**
 * Loads a Google Font via webfontloader. Uses a module-level cache to prevent duplicate loads.
 *
 * @param {string | null} fontFamily - The font family name
 */
// eslint-disable-next-line import/prefer-default-export
export function useGoogleFont(fontFamily) {
  useEffect(() => {
    if (!fontFamily || loadedFonts.has(fontFamily)) return;

    loadedFonts.add(fontFamily);

    import("webfontloader").then(WebFont => {
      WebFont.load({
        google: { families: [fontFamily] }
      });
    });
  }, [fontFamily]);
}
